import React from "react";
import {
    Box,
    Typography,
    Modal,
    Button,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccessibleIconButton from "components/base/AccessibleIconButton";

const NoodleToolsConfirmDialog = ({ open, onClose, onConfirm, loading }) => {
    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: "90vw", sm: "50vw", md: "35vw" },
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: 2,
        outline: "none",
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box sx={{ p: 4, position: "relative" }}>
                    <Typography
                        variant="h4"
                        component="div"
                        color="#406da4"
                        fontWeight="600"
                        sx={{ mb: 2 }}
                    >
                        Export to NoodleTools
                    </Typography>
                    <AccessibleIconButton
                        title="Close"
                        onClick={onClose}
                        sx={{ position: "absolute", right: 16, top: 16 }}
                    >
                        <CloseIcon />
                    </AccessibleIconButton>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                        <Typography>
                            Are you sure you want to export this citation to NoodleTools?
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            There can be some mistakes, please ensure your citation is correct
                            before adding.
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        backgroundColor: "secondary.main",
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 5,
                        px: 5,
                        py: 3,
                        borderBottomLeftRadius: "inherit",
                        borderBottomRightRadius: "inherit",
                    }}
                >
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        disabled={loading}
                        sx={{
                            width: "45%",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onConfirm}
                        disabled={loading}
                        variant="contained"
                        sx={{
                            width: "45%",
                            display: "flex",
                            gap: 1,
                        }}
                    >
                        {loading && <CircularProgress size={20} />}
                        Confirm
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default NoodleToolsConfirmDialog;
